export default __webpack_public_path__ + "static/Courcheval-France-0704932d127a79ffb4d89e6af5eeff2c.jpg";